module.exports = __webpack_public_path__ + "static/media/handheldCardSuyo.97aaf953.png";